/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

declare let adobeIMS: AdobeIMS;

import {learnSupportedLangs} from './LearnConstants';

export default class LearnUtils {
	/**
	 * [getIMSData consolidates the IMS data for the current user that is passed to the view]
	 * @returns {Object} object containing IMS data for the current user
	 */
	static getIMSData() {
		const imsData = {
			token: adobeIMS.getAccessToken(),
			name: adobeIMS.getUserProfile()?.first_name,
			email: adobeIMS.getUserProfile()?.email,
			userId: window.cchome.util.getUserId(),
		};

		return imsData;
	}

	// TODO: I need to make a PR inside cchome-shared to account for this profile type
	//  static checkLearnAppsInEntitlements(userEntitlements: Array<string>, locale: string, customerSegment: string) {
	// 	const learnApps = ['after_effects_cc', 'illustrator_cc', 'indesign_cc', 'lightroom_cc', 'nimbus_cc', 'photoshop_cc', 'premiere_pro_cc', 'experiencedesign_cc', 'premiere_rush_cc'];

	// 	if (window.cchome.util.hasFeature('temp_enable_animate')) {
	// 		learnApps.push('flash_professional_cc');
	// 	}

	// 	 if (window.cchome.util.hasFeature('temp_enable_dreamweaver')) {
	// 		 learnApps.push('dreamweaver_cc');
	// 	 }

	// 	if (window.cchome.util.hasFeature('temp_enable_acrobat')) {
	// 		learnApps.push('acrobat_dc_pro');
	// 	}

	// 	const userLearnApps = [];
	// 	const determineUserEntitlements = (customerSegment === 'unknown') ? learnApps : userEntitlements;
	// 	for (let i = 0; i < learnApps.length; i++) {
	// 		if (determineUserEntitlements.find(entitlement => entitlement === learnApps[i])) {
	// 			// Convert the entitlement app name to the app name used in the Learn component action calls. (ie. to make it compatible with the Learn Data Service)
	// 			switch (learnApps[i]) {
	// 				case 'after_effects_cc':
	// 					userLearnApps.push('aftereffects');
	// 					break;
	// 				case 'acrobat_dc_pro':
	// 					userLearnApps.push('acrobat');
	// 					break;
	// 				case 'dreamweaver_cc':
	// 					userLearnApps.push('dreamweaver');
	// 					break;
	// 				case 'flash_professional_cc':
	// 					userLearnApps.push('animate');
	// 					break;
	// 				case 'illustrator_cc':
	// 					userLearnApps.push('illustrator');
	// 					break;
	// 				case 'indesign_cc':
	// 					userLearnApps.push('indesign');
	// 					break;
	// 				case 'photoshop_cc':
	// 					userLearnApps.push('photoshop');
	// 					break;
	// 				case 'premiere_pro_cc':
	// 					userLearnApps.push('premierepro');
	// 					break;
	// 				case 'experiencedesign_cc':
	// 					userLearnApps.push('xd');
	// 					break;
	// 				case 'premiere_rush_cc':
	// 					userLearnApps.push('premiere_rush_cc');
	// 					break;
	// 				case 'lightroom_cc':
	// 				case 'nimbus_cc':
	// 					if (!userLearnApps.includes('lightroomcc')) {
	// 						userLearnApps.push('lightroomcc');
	// 					}
	// 					break;
	// 			}
	// 		}
	// 	}
	// 	return userLearnApps;
	//  }

	static isSupportedLocale(locale: string) {
		return learnSupportedLangs.includes(locale);
	}
}
